import { Injectable } from '@angular/core';
import { EVENT_SHOW_FIELD_LABEL_COMMENTS, GaEventService, IGAEvent } from '../services/ga-event.service';
import { DialogSize, GaMessageService, IDialog } from '../message/ga-message.service';
import { GA1FieldLabelDialogComponent } from './ga1-field-label-dialog.component';

export interface IGA1FieldLabel {
  faqs:string[];
  label:string;
  info:string;
}

@Injectable()
export class GA1FieldLabelService {
  constructor(
    private messageService:GaMessageService,
    private eventService:GaEventService
  ) {
    /**/
  }

  public activate():void {
    this.eventService.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_SHOW_FIELD_LABEL_COMMENTS) {
        this.showFieldLabelDialog(event.data);
      }
    });
  }

  private showFieldLabelDialog(data:IGA1FieldLabel):void {
    const dialog:IDialog = this.messageService.showDialog({
      component: GA1FieldLabelDialogComponent,
      wrapperComponent: false,
      inputs: data,
      outputs: {
        onClose: ():void => dialog.hide()
      },
      size: data.faqs ? DialogSize.LG : DialogSize.MD
    });
  }
}